<h3 class="place-name clearfix">
  <a [routerLink]="placeLink">
    <span
      >{{ placeDetail.practiceName }}
      <sup hcfFootnote [footnoteText]="placeDetail.notes" *ngIf="placeDetail.notes"></sup>
    </span>
    <span
      *ngIf="placeDetail.isAffiliatedProvider"
      title="An Affiliated Provider will organise prior approval with
 us and claim on your behalf for eligible healthcare
 services - so you don't need to submit a claim. You
 may need to see an Affiliated Provider in order to be
 covered under your policy."
      class="ic-status-affiliated"></span>
    <span
      *ngIf="placeDetail.isEasyClaim"
      title="Easy-Claim partners provide a convenient way for
 Southern Cross members to claim for eligible
 healthcare services at the time of purchase."
      class="ic-status-easy-claim"></span>
    <span *ngIf="placeDetail.isConsultant" class="is-consultant" title="{{ settings.values.consultIconTitle }}"></span>
    <span
      *ngIf="placeDetail.isTelehealth"
      class="is-telehealth"
      title="{{ settings.values.virtualConsultationTitle }}"></span>
  </a>
</h3>
<div class="place-info">
  <div class="place-contact-info">
    <div
      class="ic-phone"
      *ngIf="placeDetail.phones && placeDetail.phones.length"
      [innerHTML]="placeDetail.phones | phoneArrayLinked"></div>
    <div class="ic-address">
      <div class="facility-name" *ngIf="placeDetail.facilityName && placeDetail.facilityName !== placeDetail.address">
        {{ placeDetail.facilityName }}
      </div>
      <div *ngIf="placeDetail.receptionLocation" class="reception">
        {{ placeDetail.receptionLocation }}
      </div>
      {{ placeDetail.address }}
      <div *ngIf="placeDetail.suburb">{{ placeDetail.suburb }}</div>
      <div *ngIf="placeDetail.city || placeDetail.postcode"> {{ placeDetail.city }} {{ placeDetail.postcode }} </div>
    </div>
    <div class="ic-web" *ngIf="placeDetail.webAddress">
      <a href="{{ placeDetail.webAddress }}" target="_newtab">{{ placeDetail.webAddress | webAddress }}</a>
    </div>
  </div>
  <span class="divider"></span>
  <ul class="place-service-categories">
    <li *ngFor="let service of services" class="service">
      {{ service }}
    </li>
  </ul>
</div>
